import React, { Component } from 'react'
import { connect } from 'react-redux';

import moment from 'moment';

import ReactToPrint from 'react-to-print';

import { GetWeeklyDinings} from '../../actions/diningActions.js';

import { Modal, Paper, Grid, IconButton } from '@material-ui/core'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import FasEggFried from '../../assets/svgs/solid/egg-fried'
import FasCheeseburger from '../../assets/svgs/solid/cheeseburger'
import FasTurkey from '../../assets/svgs/solid/turkey'
import html2canvas from 'html2canvas';




class PrintPreview extends Component {

    constructor(props){
        super();
        this.state={
            today:new Date(),
            startWeek: new Date(),
            endWeek:new Date(),
            breakfasts:undefined,
            lunchs:undefined,
            dinners:undefined,
            disabledIcon:true,
            stepCount:0,
            maxElements: 8,
            showDiningMenu: true,
            startImageProcess: true,
            inProgress: false
        };
    }

    async componentDidMount(){
        const data = await this.props.GetWeeklyDinings(localStorage.getItem('communityId'));

        let sw = moment(new Date()).startOf('week');
        let ew = moment(new Date()).endOf('week');

        this.setState({startWeek:new Date(sw), endWeek: new Date(ew)});


        let breakfast = (data)? data.filter(x=>x.type===1 && !x.hideOnPrinting):[]
        let lunch = (data)? data.filter(x=>x.type===2 && !x.hideOnPrinting):[]
        let dinner = (data)? data.filter(x=>x.type===3 && !x.hideOnPrinting):[]

        this.setState({
            breakfasts:[...breakfast],
            lunchs:[...lunch],
            dinners:[...dinner]
        }, 
        // () => this.startImageProcess()
        )

      

   


    }

    AddStep = (step) =>{

        let futureStep = this.state.stepCount? this.state.stepCount : 0 ;

        if(step === 1){
            futureStep = futureStep +1;
        } else{
            futureStep = futureStep -1;
        }

        if(step===1){
            let add1Week = moment(this.state.startWeek).add(1,'week');
            let endWeek = moment(add1Week).add(1,'week');


            this.setState({startWeek:new Date(add1Week), endWeek: new Date(endWeek), stepCount:futureStep, disabledIcon:false, showDiningMenu:true,startImageProcess: true, inProgress:false});

        }else{
            let substract1Week = moment(this.state.startWeek).subtract(1,'week');
            let endWeek = moment(substract1Week).add(1,'week');

            if(moment(this.state.startWeek).format('WW') === moment(this.state.today).format('WW') && moment(this.state.startWeek).format('YYYY')=== moment(this.state.today).format('YYYY')){
                this.setState({startWeek:new Date(substract1Week), endWeek: new Date(endWeek), stepCount:futureStep, disabledIcon:true, showDiningMenu:true,startImageProcess: true,inProgress:false});

            }else{
                this.setState({startWeek:new Date(substract1Week), endWeek: new Date(endWeek), stepCount:futureStep, showDiningMenu:true,startImageProcess: true, inProgress:false} );
            }
        }

     
    };

    days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];



    //Components
    HeaderComponent = () =>{
        return (
            <Grid item container xs={12} justifyContent='space-between' alignItems='center' style={{heigh:'10%', marginBottom:'1rem'}} >
                <Grid item container className="ModalTitle" xs={12} sm={12} md={6} lg={9} justifyContent='flex-start'>
                    <Grid>Print Preview</Grid>
                    
                    <Grid item container  xs={2} sm={2} md={2} lg={1} justify='center' alignItems='center'>
                        <IconButton aria-label="leftArrow" onClick={() => this.AddStep(-1)} id='scheduler_left_arrow'  disabled={this.state.disabledIcon}>
                            <ArrowBackIosIcon style={{ fontSize: 30, color:(this.state.disabledIcon===false)?'#009EDD':'white' }}/> 
                        </IconButton>
                    </Grid>
                    <Grid item container  xs={2} sm={2} md={2} lg={1} justify='center' alignItems='center'>
                        <IconButton aria-label="RightArrow" onClick={() => this.AddStep(1)} id='scheduler_right_arrow'>
                            <ArrowForwardIosIcon color='secondary' style={{ fontSize: 30 }}/>
                        </IconButton>
                    </Grid>
                    
                </Grid>
                <Grid item container xs={12} sm={12} md={6} lg={3} justify='space-around' alignContent='flex-start' style={{padding:'0px 10px', color:'white'}}>
                    <Grid item>
                        <ReactToPrint
                            trigger={() => (                                
                                <Grid item 
                                    id='PrintScheduleBtn'
                                    style={{width:'200px', maxHeight:'70px', overflow:'hidden'}}
                                    className={(this.state.showDiningMenu)? "blueBottomButon appbtnBarButton" : "disableBottomButon appbtnBarButton"}
                                    disabled={!(this.state.showDiningMenu)}
                                >
                                    Print
                                </Grid> 
                            )}
                            content={() => this.componentRef}
                            onAfterPrint={ () => this.props.onClose? this.props.onClose() : undefined}
                        />
                    </Grid>

                    <Grid id='Print-modal-close-button' item style={{fontSize:'35px', cursor:'pointer', color:'#8f8d8d'}} onClick={() => this.props.onClose? this.props.onClose() : undefined}>
                        X
                    </Grid>
                </Grid>
            </Grid>                  
        )
    }

    convertToImageProcess = async () =>{
        try{
            let idContainerIndividualElements = 'containerDiningMenuContentImageIndividualElements';
            let canvasObject = await this.getCanvas(idContainerIndividualElements);

            let idContainer = 'containerDiningMenuContentImage';
            let res= await this.placeCanvasInContainer(canvasObject, idContainer)
            
            await this.resizePreviewImage(idContainer);
                
            idContainer = 'menuContainer';
            canvasObject = await this.getCanvas(idContainer);

            idContainer = 'containerDiningMenuContentImage';
            res= await this.placeCanvasInContainer(canvasObject, idContainer)


            this.setState({showDiningMenu: true})

            return res;
        }catch(err){ return undefined}
    }


    getCanvas= async (idContainer) =>{
        try{

            if(!idContainer) return undefined;


            const previewElement = document.getElementById(idContainer);
            
            let newCanvas = undefined;

            if(!previewElement) return undefined;
            
            newCanvas = await html2canvas(previewElement, {logging: false, allowTaint: true,useCORS: false})
            return newCanvas;
        }catch(err){ return undefined}
    }

    renderDiningType(type) {
        switch (type) {
            case 1:
                return "Breakfast";
            case 2:
                return "Lunch";
            case 3:
                return "Dinner";
            default:
                return "";
        }
    };

    resizePreviewImage= async (idContainer) =>{
        const element = document.getElementById(idContainer);
        if(!element) return undefined;

        const firstChild = element.firstChild;

        let height =undefined;
        let width = undefined;

        if(firstChild){
            const canvasStyleAtt = firstChild.getAttribute('style')
            const arrayWidthAndHeight =  (canvasStyleAtt && canvasStyleAtt.length > 0)? canvasStyleAtt.split(';'): undefined;
            if(arrayWidthAndHeight && arrayWidthAndHeight.length > 2){

                let pWidth = undefined;
                let pHeight = undefined;

                for(let i =0; i< 2; i++){
                    const current = arrayWidthAndHeight[i].toLowerCase().trim();

                    if(current.startsWith('width')){
                        const arrayW = current.split(':')

                        if(arrayW && arrayW.length=== 2){
                            pWidth = arrayW[1].trim(';').trim();
                        }
                    }else if(current.startsWith('height')){
                        const arrayH = current.split(':')

                        if(arrayH && arrayH.length=== 2){
                            pHeight = arrayH[1].trim(';').trim();
                        }
                    }
                }

                if(pWidth && pHeight){
                    pWidth = parseInt(pWidth.trim('px'));
                    pHeight = parseInt(pHeight.trim('px'));
                }

                if(Number.isInteger(pWidth) && Number.isInteger(pHeight)){
                    height = pHeight;
                    width = pWidth;
                }
            }
    
            const scale = .95
            if(height && width){
                height = height * scale;
                width = width * scale;
            }            

        firstChild.style=` height: ${height}px; width:${width}px`

        }        

        return ''
    }

    placeCanvasInContainer = async(canvasObj, idContainer) =>{
        try{
            if(!canvasObj || !idContainer) return undefined;

            const container = document.getElementById(idContainer);
            container.replaceChildren(canvasObj);

            return '';
        }catch(err){
            return undefined}
    }

    ContentDateComponent = () =>{
        
        if(!this.state.startWeek) return undefined;
        const momentToday = new moment(this.state.startWeek);

        const startOfWeek = momentToday.clone().startOf('Week');
        const endOfWeek = momentToday.clone().endOf('Week');

        const numberStartMonth = startOfWeek.format('MM');
        const numberEndMonth = endOfWeek.format('MM');

        let dateStringHTML = undefined;

        if(numberStartMonth === numberEndMonth){
            dateStringHTML = 
                <Grid item>
                    <strong className='GothamBold'>{startOfWeek.format('MMMM')}</strong>
                    {` ${startOfWeek.format('YYYY')}`}
                </Grid>
        }else{
            dateStringHTML = 
            <Grid item>
                <strong className='GothamBold'>{startOfWeek.format('MMMM')}</strong>
                {` ${startOfWeek.format('YYYY')} - `}
                <strong className='GothamBold'>{endOfWeek.format('MMMM')}</strong> 
                {` ${endOfWeek.format('YYYY')}`}
            </Grid>
        }
        

        return(
        <Grid item className='contentDateComponent'>
            {dateStringHTML}
        </Grid>)
    }

    ContentCommunityLogoComponent = () =>{
        if(!this.props.currentCommunity ||  !this.props.currentCommunity.communityLogoUrl) return undefined;

        return(
            <Grid item container justify='flex-end'>
                <Grid item >
                    <img
                        className='ContentCommunityLogo'
                        alt={this.props.currentCommunity.name}
                        src={this.props.currentCommunity.communityLogoUrl}
                    />
                </Grid>
            </Grid>
        )
    }

    ContentHeaderComponent = () =>{
        return(
            <Grid item container alignContent='center' className = 'contentHeaderComponent'>
                <Grid item container xs={8}>
                    <this.ContentDateComponent />
                </Grid>
                <Grid item container xs={4}>
                    <this.ContentCommunityLogoComponent/>
                </Grid>
            </Grid>
        )
    }

    ContentDaysNamesComponent = () =>{
        const daysNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        return (
            <Grid item container>
            {
                (daysNames && daysNames.length === 7)?
                daysNames.map( (day, index) => {
                    return(
                        <Grid item container key={`contentDayHeader_${index}`} className='dayNameCell' justify='center' alignContent='center'>
                            <Grid item>{day.toUpperCase()}</Grid>
                        </Grid>
                    )
                })
                :
                undefined
            }
            </Grid>
        )
    }

    ContentMealHeaderComponent = ({mealType}) =>{
        
        if(!mealType) return undefined;

        let Icon = undefined;

        let mealTime = undefined;
        const communityTimeZone = (this.props.currentCommunity && this.props.currentCommunity.timeZoneName)? this.props.currentCommunity.timeZoneName: undefined;
        const mealsArray = (this.props.currentCommunity && this.props.currentCommunity.mealsTime) ? this.props.currentCommunity.mealsTime : undefined;
        let mealFound = undefined
        let mealNumber = undefined;
        switch(mealType.toLowerCase()){
            case 'breakfast':
                Icon = <FasEggFried/>
                mealNumber=1;
                break;
            case 'lunch':
                Icon = <FasCheeseburger/>
                mealNumber=2;
                break;
            case 'dinner':
                Icon = <FasTurkey/>
                mealNumber = 3;
                break;
            default:
                mealNumber = 0;
                break;
        }

        if(mealNumber && mealsArray){
            mealFound = mealsArray.find( meal => meal.mealType === mealNumber);
        }


        if(mealFound){
            let localStringStart = new Date(mealFound.timeStart).toLocaleString('en-US',{timeZone: communityTimeZone})
            let localStringEnd= new Date(mealFound.timeEnd).toLocaleString('en-US',{timeZone: communityTimeZone})

            let start = new moment(localStringStart);
            let end = new moment(localStringEnd);

            const startDayTime = start.format('A')
            const endDayTime = end.format('A');

            if(startDayTime === endDayTime){
                mealTime = `${start.format('hh:mm')} - ${end.format('hh:mm A')}`;
            }else{
                mealTime = `${start.format('hh:mm A')} - ${end.format('hh:mm A')}`;
            }
            


        }

        return (
            <Grid item container className='mealHeaderStyles' >
                <Grid item container xs={6}  alignContent='center' alignItems='center'>                    
                    <Grid item className='mealIconStyles'>{Icon}</Grid> 
                    <Grid item className='mealNameStyles'> {mealType}</Grid>
                    <Grid item className='mealTimeStyles' >{mealTime}</Grid>
                </Grid>
            </Grid>
        )
    }

    ContentMealHeaderRowComponent= ({mealType}) =>{
        if(!mealType) return <Grid item container></Grid>;

        return (
            <Grid item container>
                <this.ContentMealHeaderComponent mealType={mealType}/>
            </Grid>
        )
    }

    ContentMenuIndividualMeal = ({mealType, meal, index, dayNumber}) =>{
        try{
            if(!mealType )  return <Grid item container></Grid>

            let columnsMeal = (index === 0 && mealType.toLowerCase() === 'breakfast' )? 78: 100;

            const nameLength = (columnsMeal === 100)? 50: 36;

            const newName = (meal && meal.name && meal.name.length >= nameLength  && nameLength !== 50)? meal.name.slice(0, nameLength) +'...' : (meal && meal.name)? meal.name : undefined;

            return(
                <Grid item container className='diningMenuInidvidualMeal' >
                    <Grid item container style={{width: `${columnsMeal}%`}} className='diningMenuMealName' justify='flex-start' alignContent={(columnsMeal === 100)?  'flex-start': 'flex-end'}>
                        <Grid item>{newName}</Grid>
                    </Grid>
                    {
                        (columnsMeal !== 100)?
                        <Grid item container className='diningMenuDateNumber' justify='flex-end' style={{width:`${100-columnsMeal}%`}}>
                            <Grid item >{dayNumber}</Grid>
                        </Grid>
                        :
                        undefined
                    }
                </Grid>
            )
        }catch(err){
            return <Grid item container></Grid>
        }
    }

    getMealsForToday = (mealType, date) =>{
        try{
            let meals =  undefined;

            switch(mealType.toLowerCase()){
                case 'breakfast':
                    meals = this.state.breakfasts;
                    break;
                case 'lunch':
                    meals = this.state.lunchs;
                    break;
                case 'dinner':
                    meals = this.state.dinners;
                break;
                default:
                    meals = '';
                    break;
            }

            if(!mealType || !date  || !meals) return undefined;

            let mealsForToday = meals.filter(meal => (new moment(meal.dateStart) > date.startOf('day')  && new moment(meal.dateEnd) < date.endOf('day')? true: false));
            
            if(mealsForToday){
                mealsForToday = mealsForToday.sort((a,b) => a.datestart < b.dateStart);
                mealsForToday = (mealsForToday && mealsForToday.length >=8)? mealsForToday.slice(0,8): mealsForToday;
            }

            return mealsForToday;
        }catch(err){
            return undefined;
        }
    }
    ContentMealMenuColumn = ({mealType, date}) =>{
        try{
            
            let mealsForToday = this.getMealsForToday(mealType, date);

            if(!mealType || !date ) return <Grid item container></Grid>

            const dayNumber = date.clone().format('D');
            return(
                <Grid item container alignContent='flex-start' style={{ padding:'0px 5px'}}>
                    {
                        (mealsForToday && mealsForToday.length > 0)?
                            mealsForToday.map( (meal, index) => {
                                return(
                                    <Grid item container key={`ContentMenuIndividualMeal_${index}`} >
                                        <this.ContentMenuIndividualMeal  mealType= {mealType} meal={meal} index ={index}  dayNumber={dayNumber}/>
                                    </Grid>
                                )
                            })
                            :
                            <Grid item container>
                                <this.ContentMenuIndividualMeal  mealType= {mealType} meal={undefined} index ={0}  dayNumber={dayNumber}/>
                            </Grid>
                    }
                </Grid>
            )

        }catch(err){
            return <Grid item container></Grid>
        }
    }

    ContentMealMenuCellComponent= ({mealType, date, index}) =>{
        try{
            if(!mealType || !date) return <Grid item container></Grid>

            let backgroundColor = undefined;

            if(index %2 ===1){
                backgroundColor ='#dee9ee'
            }

            return(
               <Grid item container style={{backgroundColor: backgroundColor}}>
                    <this.ContentMealMenuColumn mealType={mealType} date={date}/>
                </Grid>
            )
        }catch(err){
            return <Grid item container></Grid>
        }
    }

    ContentMealMenuRowComponent = ({mealType}) =>{
        try{
            const days=[0,1,2,3,4,5,6]

            const date = (this.state.startWeek)? new moment(this.state.startWeek): undefined;
            const startOfWeek = date.clone().startOf('week');                
            
            if(!mealType || !date) return <Grid item container></Grid>

            return(
                <Grid item container className='MenuRow'>
                {
                    (days && days.length === 7)?
                    days.map( (day, index) =>{

                        const dayOfCell = startOfWeek.clone().add(index, 'days');
                        return(
                            <Grid item container className='MealMenuCell'  key={`ContentMealMenuCellComponent_${index}`}>
                                <this.ContentMealMenuCellComponent mealType={mealType} date ={dayOfCell} index={index}/>
                            </Grid>
                        )
                    })
                    :
                    undefined
                }
                </Grid>
            )
        }catch(err){
            return <Grid item container></Grid>
        }
    }

    ContentMealsComponent = () =>{
        const meals= ['Breakfast', 'Lunch', 'Dinner']


        return (
            <Grid item container>
            {
                (meals && meals.length === 3)?
                meals.map( (mealType, index) =>{
                    return(
                        <Grid item container key={`mealRow_${mealType}`}>
                            <this.ContentMealHeaderRowComponent mealType={mealType}/>
                            <this.ContentMealMenuRowComponent mealType={mealType}/>
                        </Grid>
                    )
                })
                :
                undefined
            }
            </Grid>
        )
    }

    ContentComponnet = () =>{
        return (
            <Grid item container>
                <Grid item container className='containerDiningMenuSize' justify='center' alignContent='center' style={{padding:'20px 0px'}}>
                    <Grid item container id='menuContainer' className='diningMenuContainer' justify='center' alignContent='flex-start'  style={{zIndex:this.state.showDiningMenu? '3':'-3', paddingTop:'10px'}}>
                        <Grid item id={'containerDiningMenuContentImage'}    >
                        </Grid>
                    </Grid>

                    {/* display:!this.state.showDiningMenu?'flex': 'none'  , */}
                    
                    <Grid item container  justify='center' className={this.fnBrowserDetect() ? 'printMenuSafariStyles diningMenuContainer' : 'diningMenuContainer'}  alignContent='flex-start' style={{ zIndex:'3', }} ref={el => (this.componentRef = el)}>
                        <Grid item  container alignContent='flex-start'  id='containerDiningMenuContentImageIndividualElements'>
                            <Grid item container>
                                <this.ContentHeaderComponent/>
                            </Grid>
                            <Grid item container style={{backgroundColor:'#009edd'}}>
                                <this.ContentDaysNamesComponent/>
                            </Grid>
                            <Grid item container>
                                <this.ContentMealsComponent/>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        )
    }

    startImageProcess = () =>{
        try{

            const data =(this.state.breakfasts || this.state.lunchs || this.state.dinners )? true: false;

            if(!this.state.showDiningMenu && !this.state.inProgress && data){
                this.setState({inProgress: true},
                    async () =>{
                            await this.convertToImageProcess();
                        }
                )
            }
        }catch(err){
            return undefined;
        }
    }

    fnBrowserDetect() {

        let userAgent = navigator.userAgent;
        let isSafari = false;

        if (userAgent.match(/safari/i)) 
            isSafari = true;

        return isSafari
    }


    render() {

        // this.startImageProcess()

        return (
            <>

                <Modal
                    open={true}
                    onClose={() => this.props.onClose()}
                >
                    <Paper elevation={3}>
                            <Grid item container className="diningMenuPreviewModal" id='dining_print_preview'>
                                <Grid item container style={{height:'10%'}}>
                                    <this.HeaderComponent/>
                                </Grid>
                                <Grid item container style={{height:'90%', overflow:'auto'}}>
                                    <this.ContentComponnet/>
                                </Grid>
                            </Grid>
                    </Paper>

                </Modal>
                
            </>
        )
    }
}

function mapStateToProps(state) {
  
    let weeklyDinings = (state.diningReducer && state.diningReducer.weekDinings)? state.diningReducer.weekDinings: [];
    let isLoading = (state.diningReducer && state.diningReducer.loading)? state.diningReducer.loading : false;


    let currentCommunity = (state.communityReducer && state.communityReducer.communityData)? state.communityReducer.communityData.find(c=>c.communityId===localStorage.getItem('communityId')):undefined;
    return{
        weeklyDinings,
        currentCommunity,
        isLoading
    }
}

export default connect(mapStateToProps, {GetWeeklyDinings})(PrintPreview);
 